var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7802 17.7146C10.9375 18.1255 7.0619 18.1255 3.21918 17.7146C2.47425 17.635 1.77908 17.3026 1.24942 16.7727C0.719767 16.2429 0.387583 15.5476 0.308181 14.8026C-0.102727 10.9599 -0.102727 7.08436 0.308181 3.24164C0.387838 2.49671 0.720262 1.80154 1.2501 1.27189C1.77994 0.742228 2.47522 0.410044 3.22018 0.330642C7.06289 -0.0802661 10.9385 -0.0802661 14.7812 0.330642C15.5261 0.410299 16.2213 0.742723 16.7509 1.27256C17.2806 1.8024 17.6128 2.49768 17.6922 3.24264C18.1031 7.08536 18.1031 10.9609 17.6922 14.8036C17.6127 15.5486 17.2803 16.2439 16.7505 16.7736C16.2206 17.3033 15.5252 17.6354 14.7802 17.7146Z",
    fill: "url(#paint0_linear_1180_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.713 3.8935C16.6427 3.23242 16.348 2.61539 15.878 2.1452C15.408 1.67502 14.7911 1.38007 14.13 1.3095C10.7201 0.94501 7.281 0.94501 3.87104 1.3095C3.20988 1.38003 2.59283 1.67494 2.12266 2.14511C1.65249 2.61528 1.35758 3.23233 1.28704 3.8935C0.922548 7.30345 0.922548 10.7425 1.28704 14.1525C1.3574 14.8137 1.65225 15.4309 2.12246 15.9011C2.59266 16.3713 3.20981 16.6661 3.87104 16.7365C7.28099 17.1011 10.7201 17.1011 14.13 16.7365C14.7913 16.6661 15.4084 16.3713 15.8786 15.9011C16.3488 15.4309 16.6437 14.8137 16.714 14.1525C17.0784 10.7425 17.078 7.30341 16.713 3.8935Z",
    fill: "url(#paint1_linear_1180_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.27002 14.4243C0.282686 14.549 0.295353 14.6733 0.30802 14.7973C0.387499 15.5423 0.719864 16.2376 1.24974 16.7673C1.77961 17.297 2.47499 17.6291 3.22002 17.7083C7.06273 18.1193 10.9383 18.1193 14.781 17.7083C15.5259 17.6289 16.221 17.2967 16.7507 16.767C17.2804 16.2373 17.6126 15.5422 17.692 14.7973C17.7054 14.6727 17.7184 14.5483 17.731 14.4243H0.27002Z",
    fill: "url(#paint2_linear_1180_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1009 3.02051C11.728 3.02051 11.3586 3.09397 11.0141 3.23669C10.6695 3.37942 10.3564 3.58861 10.0927 3.85233C9.82901 4.11604 9.61982 4.42912 9.4771 4.77369C9.33437 5.11825 9.26091 5.48756 9.26091 5.86051V7.98051H7.73291V10.6065L9.26091 11.9755V18.0215C11.1046 18.0126 12.9466 17.9102 14.7799 17.7145C15.5248 17.6351 16.2199 17.3029 16.7496 16.7732C17.2792 16.2435 17.6115 15.5484 17.6909 14.8035C17.9963 11.9476 18.0749 9.07189 17.9259 6.20351L14.7459 3.02351L12.1009 3.02051Z",
    fill: "url(#paint3_linear_1180_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25691 18.0215C10.3056 18.0162 11.3542 17.9805 12.4029 17.9145V10.6065H14.4899L14.7419 7.98051H12.4069V6.31351C12.4069 6.13662 12.4772 5.96696 12.6023 5.84187C12.7274 5.71679 12.897 5.64651 13.0739 5.64651H14.7459V3.02051H12.1009C11.728 3.02051 11.3586 3.09397 11.0141 3.23669C10.6695 3.37942 10.3564 3.58861 10.0927 3.85233C9.82901 4.11604 9.61982 4.42912 9.4771 4.77369C9.33437 5.11825 9.26091 5.48756 9.26091 5.86051V7.98051H7.73291V10.6065H9.25691V18.0215Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1180_640",
    x1: 5.97612,
    y1: 2.56051,
    x2: 10.5302,
    y2: 12.2987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3457A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1180_640",
    x1: 12.4187,
    y1: 11.3712,
    x2: -3.31542,
    y2: 0.557372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3457A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3F77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1180_640",
    x1: 9.00052,
    y1: 15.0601,
    x2: 9.00052,
    y2: 17.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3457A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3F77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1180_640",
    x1: 20.6683,
    y1: 14.8863,
    x2: 7.42505,
    y2: 11.7585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3457A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#2A4C8D",
    stopOpacity: 0.325
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#22427D",
    stopOpacity: 0.706
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3F77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFf);
export default __webpack_public_path__ + "static/media/ff.46d385d6af819a598d01c3a1ac492851.svg";
export { ForwardRef as ReactComponent };